import { useTranslation } from "react-i18next";
import {
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeFontVariable,
	ThemeShadowVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import {
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalFooter,
	ModalHeader,
} from "@caspeco/casper-ui-library.components.modal";
import { Button } from "@caspeco/casper-ui-library.components.button";
import { Icons } from "@caspeco/casper-ui-library.components.icon";
import { Heading } from "@caspeco/casper-ui-library.components.heading";
import { Box } from "@caspeco/casper-ui-library.components.box";
import { IconButton } from "@caspeco/casper-ui-library.components.icon-button";
import { CartQuantityBadge } from "components/cart-quantity-badge/CartQuantityBadge";

interface IUpsellModal {
	isOpen: boolean;
	onClose: () => void;
	onOpenCart: () => void;
	children: React.ReactNode;
}

export function UpsellModal({ isOpen, onClose, onOpenCart, children }: IUpsellModal) {
	const { t } = useTranslation();

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="full">
			<ModalHeader p={ThemeSpaceVariable.Medium} display="flex" justifyContent="space-between">
				<Heading
					as="h2"
					fontWeight="bold"
					fontFamily={ThemeFontVariable.Header}
					color={ThemeColorVariable.OnSurfaceHeader}
					fontSize={{
						base: ThemeFontSizeVariable.XLarge,
						md: ThemeFontSizeVariable.X3Large,
					}}
				>
					{t("article_upsell_title")}
				</Heading>
				<ModalCloseButton />
			</ModalHeader>
			<ModalBody px={ThemeSpaceVariable.Medium} pb="32px">
				{children}
			</ModalBody>
			<ModalFooter
				pt={ThemeSpaceVariable.Medium}
				px={ThemeSpaceVariable.Medium}
				zIndex={1}
				boxShadow={ThemeShadowVariable.Footer}
				pb="calc(1em + env(safe-area-inset-bottom))"
				gap={ThemeSpaceVariable.Small}
			>
				<Button onClick={onClose} size="lg" w={{ base: "100%", md: "auto" }} variant="primary">
					{t("menu_back_to")}
				</Button>
				<Box position="relative" display={{ md: "none" }}>
					<IconButton
						size="lg"
						icon={Icons.Cart}
						id="upsell-add-to-cart-button"
						variant="primary"
						onClick={onOpenCart}
						aria-label={t("purchase_cart_show")}
					/>
					<CartQuantityBadge top="-4px" right="-2px" />
				</Box>
			</ModalFooter>
		</Modal>
	);
}
